import AdditionalArticlesContainer from "./components/AdditionalArticlesContainer";
import ArticleBoxLogo from "./components/ArticleBoxLogo";
import ArticleBoxLongTitle from "./components/ArticleBoxLongTitle";
import ArticleBoxMini from "./components/ArticleBoxMini";
import ArticleFolderItem from "./components/ArticleFolderItem";
import ArticleFolderTab from "./components/ArticleFolderTab";
import ArticleFolderTitle from "./components/ArticleFolderTitle";
import ArticleInfoTitle from "./components/ArticleInfoTitle";
import ArticleMutualAidBoxMini from "./components/ArticleMutualAidBoxMini";
import ArticleOfferContactTabs from "./components/ArticleOfferContactTabs";
import ArticleOfferTitle from "./components/ArticleOfferTitle";
import ArticleText from "./components/embedded/ArticleText";
import BorderedEmbeddedArticle from "./components/embedded/BorderedBox";
import ButtonEmbeddedArticle from "./components/embedded/Button";
import CalculationResult from "./components/CalculationResult";
import ColoredBoxesEmbeddedArticle from "./components/embedded/ColoredBoxes";
import ColorContainer from "./components/ColorContainer";
import DiaporamaEmbeddedArticle from "./components/embedded/Diaporama";
import ExpandBoxEmbeddedArticle from "./components/embedded/ExpandBox";
import ExpandWithTitleEmbeddedArticle from "./components/embedded/ExpandWithTitle";
import ExpertInfoEventSection from "./components/ExpertInfoEventSection";
import ExpertInfoSection from "./components/ExpertInfoSection";
import FeedbackSection from "./components/FeedbackSection";
import FontControl from "./components/FontControl";
import GreenIconEmbeddedArticle from "./components/embedded/GreenIconBox";
import Indicators from "./components/embedded/Indicators";
import MoreInfoEmbeddedArticle from "./components/embedded/MoreInfo";
import OutputArticleEventDate from "./components/OutputEventDate";
import RestrictedRichText from "./components/RestrictedRichText";
import RestrictedRichTitle from "./components/RestrictedRichTitle";
import SimpleList from "./components/SimpleList";
import SocialSharingLink from "./components/SocialSharingLink";
import SolutionEmbeddedArticle from "./components/embedded/SolutionBox";
import PreventionEmbeddedArticle from "./components/embedded/PreventionBox";
import TitleImage from "./components/TitleImage";
import VideoBoxEmbeddedArticle from "./components/embedded/VideoBox";
import CallToActionSectionEmbeddedArticle from "./components/embedded/CallToActionSection";

import "Styles/section/section.less";
import "Styles/accordion/accordion.less";

const components = {
    additionalArticlesContainer: AdditionalArticlesContainer,
    articleBoxLogo: ArticleBoxLogo,
    articleBoxLongTitle: ArticleBoxLongTitle,
    articleBoxMini: ArticleBoxMini,
    articleFolderItem: ArticleFolderItem,
    articleFolderTitle: ArticleFolderTitle,
    articleFolderTab: ArticleFolderTab,
    articleInfoTitle: ArticleInfoTitle,
    articleMutualAidBoxMini: ArticleMutualAidBoxMini,
    articleOfferContactTabs: ArticleOfferContactTabs,
    articleOfferTitle: ArticleOfferTitle,
    articleText: ArticleText,
    borderedEmbeddedArticle: BorderedEmbeddedArticle,
    buttonEmbeddedArticle: ButtonEmbeddedArticle,
    calculationResult: CalculationResult,
    coloredBoxesEmbeddedArticle: ColoredBoxesEmbeddedArticle,
    colorContainer: ColorContainer,
    diaporamaEmbeddedArticle: DiaporamaEmbeddedArticle,
    expandBoxEmbeddedArticle: ExpandBoxEmbeddedArticle,
    expandWithTitleEmbeddedArticle: ExpandWithTitleEmbeddedArticle,
    expertInfoEventSection: ExpertInfoEventSection,
    expertInfoSection: ExpertInfoSection,
    feedbackSection: FeedbackSection,
    fontControl: FontControl,
    greenIconEmbeddedArticle: GreenIconEmbeddedArticle,
    indicators: Indicators,
    moreInfoEmbeddedArticle: MoreInfoEmbeddedArticle,
    outputArticleEventDate: OutputArticleEventDate,
    restrictedRichText: RestrictedRichText,
    restrictedRichTitle: RestrictedRichTitle,
    simpleList: SimpleList,
    socialSharingLink: SocialSharingLink,
    solutionEmbeddedArticle: SolutionEmbeddedArticle,
    preventionEmbeddedArticle: PreventionEmbeddedArticle,
    titleImage: TitleImage,
    videoBoxEmbeddedArticle: VideoBoxEmbeddedArticle,
    callToActionSectionEmbeddedArticle: CallToActionSectionEmbeddedArticle
};

export default components;
